import React from 'react';
import handshakePurple from '../assets/handshake-purple.png';

/** Purple handshake — brand-standard replacement for yellow 🤝 emoji. */
export default function HandshakeIcon({ size = 20, alt = 'Handshake', className = '', style = {} }) {
  return (
    <img
      src={handshakePurple}
      alt={alt}
      className={className}
      style={{
        width: size,
        height: size,
        objectFit: 'contain',
        display: 'inline-block',
        verticalAlign: 'middle',
        ...style,
      }}
    />
  );
}
